// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"331":"d810769f","680":"5d3bf779","812":"fe0ab94d"}[chunkId] + ".css";
};